export default __webpack_public_path__ + "static/media/past-black.7a5c4e76.svg";